import React, { memo } from 'react';
import { useTheme } from '@mui/material/styles';

import darkModeLogo from '../../assets/ps_auth_logo_dark_mode.svg';
import lightModeLogo from '../../assets/ps_auth_logo_light_mode.svg';

import './app-header.scss';

const AppHeader = () => {
  const theme = useTheme();
  const logo = theme.palette.mode === 'dark' ? darkModeLogo : lightModeLogo;

  return (
    <div className="app-header">
      <img src={logo} alt="app-header-logo" />
    </div>
  );
};

export default memo(AppHeader);
